import { BehaviorSubject } from 'rxjs';

export class IntroService {
  readonly introViewed$ = new BehaviorSubject(false);

  setIntroViewed = (): void => this.introViewed$.next(true);
}

